import { GynecologicalInterview } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { MedicalDataIcon, SidePanelList } from '@dreryk/react-components';

import { useGynecologicalInterviewSidePanelListItems } from './GynecologicalInterviewSidePanelList.hooks';

type GynecologicalInterviewSidePanelListProps = {
   readonly gynecologicalInterviews: GynecologicalInterview[];
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const GynecologicalInterviewSidePanelList = (props: GynecologicalInterviewSidePanelListProps): JSX.Element => {
   return (
      <SidePanelList
         icon={<MedicalDataIcon />}
         items={useGynecologicalInterviewSidePanelListItems(
            props.gynecologicalInterviews,
            props.onMedicalDataAccessAuthorizationUpdate
         )}
         noItemsMessage={createTranslatedText('')}
      />
   );
};
